import { SuspenseLoading } from '@/components/SuspenseErrorBoundary/fallback';
import { IpAddressWhitelistsTable } from '@/features/ip_address_whitelists/components/IpAddressWhitelistsTable/IpAddressWhitelistsTable';
import { IpAddressWhitelistUpsertModal } from '@/features/ip_address_whitelists/components/IpAddressWhitelistUpsertModal/IpAddressWhitelistUpsertModal';
import { useIpAddressWhitelistList } from '@/features/ip_address_whitelists/IpAddressWhitelistList/hooks/useIpAddressWhitelistList';
import type { IpAddressWhitelistListViewProps } from '@/features/ip_address_whitelists/IpAddressWhitelistList/types';
import { FC, memo, Suspense } from 'react';

const InnerIpAddressWhitelistListView: FC<IpAddressWhitelistListViewProps> =
  memo(
    ({
      isEditingRestrict,
      onIsEditingWhitelistChange,
      onIsEmptyChange,
      setInlineError,
      officeId,
    }) => {
      const {
        whitelistRows,
        isWhitelistEmpty,
        isDeleteBlockedByRestriction,
        isMutating,
        isAddModalOpen,
        editingRowId,
        inlineFormControl,
        isInlineSaveDisabled,
        onSaveInline,
        onCancelInline,
        onClickAdd,
        onStartEditRow,
        onDeleteRow,
        onCloseAddModal,
        onAddSubmit,
        ConfirmDeleteModal,
      } = useIpAddressWhitelistList({
        onIsEditingChange: onIsEditingWhitelistChange,
        onIsEmptyChange,
        setInlineError,
        officeId,
      });

      return (
        <>
          <IpAddressWhitelistsTable
            data={whitelistRows}
            isWhitelistEmpty={isWhitelistEmpty}
            isLoading={isMutating}
            isEditingRestrict={isEditingRestrict}
            isDeleteBlockedByRestriction={isDeleteBlockedByRestriction}
            isAddModalOpen={isAddModalOpen}
            editingRowId={editingRowId}
            inlineFormControl={inlineFormControl}
            isInlineSaveDisabled={isInlineSaveDisabled}
            onSaveInline={onSaveInline}
            onCancelInline={onCancelInline}
            onClickAdd={onClickAdd}
            onStartEditRow={onStartEditRow}
            onDeleteRow={onDeleteRow}
          />
          <IpAddressWhitelistUpsertModal
            open={isAddModalOpen}
            onClose={onCloseAddModal}
            onSubmit={onAddSubmit}
          />
          <ConfirmDeleteModal />
        </>
      );
    }
  );
InnerIpAddressWhitelistListView.displayName = 'InnerIpAddressWhitelistListView';

export const IpAddressWhitelistListView: FC<IpAddressWhitelistListViewProps> =
  memo((props) => (
    <Suspense fallback={<SuspenseLoading />}>
      <InnerIpAddressWhitelistListView {...props} />
    </Suspense>
  ));
IpAddressWhitelistListView.displayName = 'IpAddressWhitelistListView';
